import React from 'react';
import { View } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import Button from '@styles/buttons';

import type { WizardFooterProps } from '@components/tenantStatus/onboardingWizard/types';

const WizardFooter = ({ isLastStep, onBack, onNext, submitting, testIDs }: WizardFooterProps) => {
  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: scale(24),
      }}
    >
      <Button variant="L" type="Only Text" onPress={onBack} testID={testIDs?.back}>
        {i18n.t('Back')}
      </Button>
      <Button
        variant="L"
        type="Primary"
        onPress={onNext}
        loading={submitting}
        testID={isLastStep ? testIDs?.submit : testIDs?.next}
        colors={{
          bgColor: 'Other/Light/Logo/Smart',
          textColor: 'Label/Light/AlwaysLight Primary',
        }}
      >
        {isLastStep ? i18n.t('Submit') : i18n.t('Next')}
      </Button>
    </View>
  );
};

export default WizardFooter;
